
export class CurrencyConstants {

    static readonly CURRENCY_CODE_USD = 'USD';
    static readonly CURRENCY_CODE_ARS = 'ARS';

    static readonly THOUSANDS_SEPARATOR_COMMA = ',';
    static readonly THOUSANDS_SEPARATOR_DOT = '.';

  }
